export const values = Object.values;
export const entries = Object.entries;
export const freeze = Object.freeze;
export const keys = Object.keys;

export function prefixKeys<
    A extends { [key: string]: any },
    B extends string,
>(prefix: B, obj: A): {
    [Key in `${B}${keyof A extends string ? keyof A : never}`]: any
} {
    return Object.fromEntries(Object
        .entries(obj)
        .map(([ k, v ]) => [ prefix + k, v ]),
    ) as any;
}

export function postfixKeys<
    A extends { [key: string]: any },
    B extends string,
>(postfix: B, obj: A): {
    [Key in `${keyof A extends string ? keyof A : never}${B}`]: any
} {
    return Object.fromEntries(Object
        .entries(obj)
        .map(([ k, v ]) => [ k + postfix, v ]),
    ) as any;
}

export function transferStatic<S extends object, T extends Function | object>(source: S, target: T): T & S {
    for (const prop in source) {
        if (prop === 'defaultProps') continue;

        // @ts-ignore
        target[prop] = source[prop];
    }

    return target as any;
}

export function keysOf<T extends object>(obj: T): (keyof T)[] {
    return Object.keys(obj) as any;
}

export function valuesOf<T extends object>(obj: T): T[keyof T][] {
    return Object.values(obj) as any;
}
